import React from 'react'
import { Link } from 'react-router-dom'
import { CheckCircle2 } from 'lucide-react'
import { levelMeta } from './model'

// The backend's alerts, already ordered High → Watch → Info. Title and body
// are printed as sent. An alert links only when it carries `link_target`:
// the "Other buyer" ones never do, so a hidden buyer's id never reaches the
// page.
export default function AttentionCard({ alerts }) {
  return (
    <section className="card" aria-labelledby="hm-attention-title" style={{ padding: 18, display: 'flex', flexDirection: 'column', gap: 12 }}>
      <h2 id="hm-attention-title" style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>Needs your attention</h2>
      {alerts.length === 0 ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 0', color: 'var(--text-secondary)', fontSize: 13 }}>
          <CheckCircle2 size={20} aria-hidden="true" style={{ color: 'var(--green)', flexShrink: 0 }} />
          <span><strong style={{ color: 'var(--text-primary)' }}>All clear</strong> · nothing needs you right now.</span>
        </div>
      ) : (
        <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 12 }}>
          {alerts.map((a, i) => {
            const meta = levelMeta(a.level)
            return (
              <li key={`${a.kind}-${i}`} style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                <span aria-hidden="true" style={{ width: 8, height: 8, borderRadius: 999, background: meta.fg, marginTop: 6, flexShrink: 0 }} />
                <div style={{ minWidth: 0, flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                    <span style={{ fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 999, color: meta.fg, background: meta.bg }}>{meta.label}</span>
                    <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary)' }}>{a.title}</span>
                  </div>
                  <p style={{ margin: '4px 0 0', fontSize: 12, color: 'var(--text-secondary)' }}>
                    {a.body}
                    {a.link_target && <> <Link className="hm-link" to={a.link_target}>View →</Link></>}
                  </p>
                </div>
              </li>
            )
          })}
        </ul>
      )}
    </section>
  )
}
